import React, { useState, useEffect } from 'react';
import { ChevronRight, RotateCcw, Home } from 'lucide-react';
import { API_BASE_URL } from '../config';

const DiscussionGame = ({ config, onEnd }) => {
    const [items, setItems] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (config && config.items) {
            const shuffled = [...config.items].sort(() => 0.5 - Math.random());
            setItems(shuffled);
        }
    }, [config]);

    if (items.length === 0) return <div className="game-loading">Chargement...</div>;

    const item = items[currentIndex];
    const sessionLength = Math.min(items.length, 10);
    const isFinished = currentIndex >= sessionLength;

    const handleNext = () => {
        setCurrentIndex(currentIndex + 1);
    };

    if (isFinished) {
        return (
            <div className="discussion-end-card">
                <h2 className="end-title">Séance terminée</h2>
                <p className="end-subtitle">Merci pour ces beaux échanges !</p>
                <div className="end-actions">
                    <button onClick={() => window.location.reload()} className="btn-replay">
                        <RotateCcw /> Relancer
                    </button>
                    <button onClick={() => onEnd(0)} className="btn-home">
                        <Home /> Accueil
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="discussion-container">
            <div className="discussion-progress">
                Sujet {currentIndex + 1} / {sessionLength}
            </div>

            <div className="discussion-main-content">
                {item.image && (
                    <div className="discussion-image-wrapper">
                        <img
                            src={item.image.startsWith('http') ? item.image : `${API_BASE_URL}${item.image}`}
                            alt="Support de discussion"
                            className="discussion-media"
                        />
                    </div>
                )}

                <h1 className="discussion-text-highlight">
                    {item.text || item.question}
                </h1>

                {item.prompts && (
                    <div className="discussion-prompts-list">
                        {item.prompts.map((p, i) => <div key={i} className="prompt-item">• {p}</div>)}
                    </div>
                )}
            </div>

            <div className="discussion-navigation">
                <button onClick={handleNext} className="btn-next-discussion">
                    Sujet Suivant <ChevronRight size={32} />
                </button>
            </div>
        </div>
    );
};

export default DiscussionGame;